import { gql } from '@apollo/client';

const AdminUserInfo = gql`
  fragment AdminUserInfo on AdminUser {
    id
    firstName
    lastName
    email
    emailDeliverabilityStatus
    phone
    language
    state
    adminLocationId
    adminLocation {
      id
      name
    }
    roleTypeId
    roleType {
      id
      name
    }
    imageUrl
    adminTagIds
    elevatedAccess
    lastLoginAt
    createdAt
    updatedAt
  }
`;

export default AdminUserInfo;
